/**
 * The pricing of the five tarify of the legacy pujcsiauto.online (pujcovna-plan §5.5, decision 5): the starting configuration for
 * Trutnov, loaded into the tarif form by "Načíst vzor" and saved only when the admin saves. The motorhome seasons were stored as
 * days of the year on a 29-day-February scale (114, 171, 244, 306) and are written here as the calendar dates they fall on.
 */

import type { PujcovnaTarif } from './api';

export type CenikVzor = { nazev: string } & Pick<PujcovnaTarif, 'marze_proc' | 'delky' | 'sezony'>;

const OSOBNI_DELKY = [{ od: 1, koef: 1 }, { od: 5, koef: 0.85 }, { od: 11, koef: 0.73 }];

export const CENIK_VZORY: readonly CenikVzor[] = [
  { nazev: 'Osobní malé', marze_proc: 80, delky: OSOBNI_DELKY, sezony: [] },
  { nazev: 'Osobní střední a vyšší', marze_proc: 70, delky: OSOBNI_DELKY, sezony: [] },
  { nazev: 'MPV', marze_proc: 60, delky: OSOBNI_DELKY, sezony: [] },
  { nazev: 'SUV, dodávky a minibusy', marze_proc: 50, delky: OSOBNI_DELKY, sezony: [] },
  {
    nazev: 'Obytné',
    marze_proc: 97.1,
    delky: [{ od: 1, koef: 1 }, { od: 2, koef: 1 }, { od: 5, koef: 1 }, { od: 15, koef: 0.9 }],
    sezony: [
      { od: '01-01', koef: 0.7, pausal: { dny: 3, cena: 10000 } },
      { od: '04-23', koef: 1.05, pausal: { dny: 4, cena: 20000 } },
      { od: '06-19', koef: 1.05, pausal: { dny: 6, cena: 26000 } },
      { od: '08-31', koef: 1.05, pausal: { dny: 4, cena: 20000 } },
      { od: '11-01', koef: 0.7, pausal: { dny: 3, cena: 10000 } },
    ],
  },
];
